export const MEQ_DRAWER_TYPE = {
  ADD: 'add',
  EDIT: 'edit',
  SELECT: 'select',
  SELECTED: 'selected',
  SIS: 'sis'
};
